module.exports = __webpack_public_path__ + "Flag-428.25df0589b4d8d430af319bd19e60d11d.svg";